import { useCallback } from 'react';
import { useTranslation } from '../i18n';

// коды языков приложения → BCP-47 (у вас en / ru / uk)
const LOCALE_ALIASES = { ua: 'uk-UA', en: 'en-GB' };

export const resolveLocale = (i18n = {}) => {
  const raw =
    i18n.lang || i18n.language || i18n.locale ||
    (typeof navigator !== 'undefined' ? navigator.language : 'en-GB');
  return LOCALE_ALIASES[raw] || raw;
};

const DATE_OPTS = { day: '2-digit', month: '2-digit', year: 'numeric' };

export const formatLocalDate = (iso, locale) => {
  if (!iso) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  if (!m) return String(iso);
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  try {
    return d.toLocaleDateString(locale, DATE_OPTS);
  } catch {
    return d.toLocaleDateString('en-GB', DATE_OPTS);
  }
};

export const useFormatDate = () => {
  const i18n = useTranslation();
  const locale = resolveLocale(i18n);
  return useCallback((iso) => formatLocalDate(iso, locale), [locale]);
};